import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import { Grid, Paper, Typography } from "@material-ui/core";

import DefaultChart from "app/components/Chart/DefaultChart";
import { getWorkScheduleOverrideStatsFromState } from "features/planner/report/report.selectors";

class WorkScheduleOverrideDashboardSection extends PureComponent {
  render() {
    const { stats } = this.props;

    return (
      <Grid container spacing={1}>
        <Grid container item spacing={2}>
          <Grid container item>
            <Typography variant="h6">Personnel status</Typography>
          </Grid>
          <Grid item xs={12}>
            <Paper elevation={1}>
              <DefaultChart
                options={{
                  chart: {
                    zoomType: "x",
                  },
                  subtitle: {
                    text: "Events - last 6 months",
                  },
                  yAxis: {
                    title: {
                      text: "Total",
                    },
                  },
                  xAxis: {
                    categories: stats.get("categories"),
                  },
                  tooltip: {
                    shared: true,
                    crosshairs: true,
                  },
                  series: stats.get("series"),
                }}
              />
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default compose(
  connect(state => ({
    stats: getWorkScheduleOverrideStatsFromState(state),
  })),
)(WorkScheduleOverrideDashboardSection);
